// extracted by mini-css-extract-plugin
export default {"hidden":"BusinessCardPage_hidden__8NoXn","pageContainer":"BusinessCardPage_pageContainer__Z2w7P","cardContainer":"BusinessCardPage_cardContainer__HbLO7"};